<div class="coordinates-measure esri-widget" [class.hidden]="!active">
    <div class="coordinates-measure-body" #coordinates></div>
    <div #footer class="coordinates-measure-footer esri-direct-line-measurement-3d__actions">
        <button class="coordinates-measure-add-layer esri-button esri-button--secondary"
                [class.btn-disabled]="currentMode === 'live' || !coordinateConversionTool || !coordinateConversionTool.currentLocation"
                [title]="currentMode === 'live' ? 'Must be in capture mode' : ''"
                (click)="createCoordinateLayer()">
            Add as Layer
        </button>
    </div>
    <label class="coordinates-measure-auto-create">
        Auto-create layers
        <input type="checkbox" [(ngModel)]="autoCreateLayer">
    </label>
</div>
